<template>
  <div
    v-if="locations"
    class="online-only message message--warn"
  >
    <IconInfoFilled
      class="message__icon icon icon--info"
      filled
    />
    <span>
      {{ $t('This product can only be ordered online') }}
    </span>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  selectedSku?: string[] | string | null
}>()

const meta = inject('meta', ref())
const { loadAvelonStockData, AvelonStockData, pendingAvelonStock } = usePDP(meta)

const currentSku = computed(() => {
  if (!props.selectedSku) return null

  if (Array.isArray(props.selectedSku) && props.selectedSku.length > 0) {
    return props.selectedSku[0].toLowerCase()
  }
  else if (typeof props.selectedSku === 'string') {
    return props.selectedSku.toLowerCase()
  }

  return null
})

onMounted(() => {
  if (pendingAvelonStock) {
    loadAvelonStockData()
  }
})

const locations = computed(() => {
  if (pendingAvelonStock.value || !AvelonStockData.value || !currentSku.value) {
    return false
  }

  const getStock = AvelonStockData.value?.getStock
  if (!getStock?.shopStock || !Array.isArray(getStock.shopStock)) {
    return false
  }

  return !getStock.shopStock.some(
    shopData =>
      Array.isArray(shopData.stockStatus) &&
      shopData.stockStatus.some(
        status => status?.sku?.toLowerCase?.() === currentSku.value && status.status > 0,
      ),
  )
})
</script>

<style src="~layers/app/components/Product/Availability/OnlineOnly.css" />
